// import Vue from 'vue'
import routes from './routes'
import * as get from '@ccforeverd/tool-get'

import { afterEachResolver } from './bar/resolver'

Vue.use(VueRouter)

export function createRouter (options) {
  const appRouter = new VueRouter({
    mode: 'history',
    base: options.baseUrl,
    routes,
    scrollBehavior (to, from, savedPosition) {
      // return 期望滚动到哪个的位置
      return { x: 0, y: 0 }
    }
  })

  const addQuery = (to, from, key) => {
    if (typeof from[key] !== 'undefined' && typeof to[key] === 'undefined') {
      to[key] = from[key]
    }
  }

  appRouter.beforeEach((to, from, next) => {

    // 视频源处理
    // if (to.meta.Intercept) {
    //   const { courseId, from, chapterId} = to.query
    //   next(false)
    //   window.location.href = `https://edu.cri.cn/wps-h5/video-detail?courseId=${courseId}&chapterId=${chapterId}&from=${from}`
    //   return
    // }

    // query通用参数
    if (to.query.route) {
      return next()
    }
    addQuery(to.query, from.query, 'client')
    addQuery(to.query, from.query, 'loginToken')
    addQuery(to.query, from.query, 'channel')
    addQuery(to.query, from.query, 'from')
    addQuery(to.query, from.query, 'order_from')
    to.query.route = 1

    next(get.add(to.fullPath, to.query))
  })

  appRouter.afterEach(afterEachResolver)

  return appRouter
}
